import React from 'react'
import { Link } from 'react-router-dom'

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash'
import Dummy from 'assets/images/tmp/layers/base_layer/dummy.png'
import { priceFormat } from 'app/utils'
import { BrowserView, MobileView, isBrowser, isMobile } from "react-device-detect";

import * as constructionsActions from '../../actions/constructions_actions';

class DoorPreview extends React.Component {
  state = {
    showModalPreview: false
  };

  renderOptions() {
    return this.props.preview_state.options.map((item, index) => {
      return (
        <li className='door-preview-block-parts-item' key={index}>
          <div className='key-'>{item.string}</div>
          <div className='value-'>{
            !!Number(item.value) ? priceFormat(Number(item.value)) : item.value
          }</div>
        </li>
      );
    });
  }

  closeModal(e) {
    e.preventDefault();
    this.setState({showModalPreview: false});
  };

  showModal(type, e) {
    e.preventDefault();
    if (type || isMobile) {
      return false;
    }
    this.setState({showModalPreview: true});
  };

  renderLayers(layers, type) {
    return (
      <div
        className={`photo-layers ${type || ''}`}
        onClick={this.showModal.bind(this, type)}
      >
        <img key={0} className='layer' src= {Dummy} />
        { layers.map((item, index) => (<img key={index} className='layer' src={item.url} style={{zIndex: item.index}} />)) }
      </div>
    );
  }

  renderPreviewPopup() {
    const layers = this.props.preview_state.preview_layers;

    return (
      <div className={`popup-layer ${this.state.showModalPreview ? 'active' : ''}`} >
        <div className='popup-wrapper door-preview-popup'>
          <div className='base-width'>
            <div className='popup'>
              <div className='popup-header'>
                <a className='close ' onClick={this.closeModal.bind(this)} href='#'>Закрыть окно</a>
                <h2>
                  Ваша дверь
                </h2>
              </div>
              <div className="door-preview-block popup-">
                { this.renderLayers(layers, 'large-preview') }
              </div>
            </div>
          </div>
          <div className='cover-all' onClick={this.closeModal.bind(this)}></div>
        </div>
      </div>
    );
  }

  render() {
    let
      state = this.props.preview_state,
      selectedType = this.props.constructions_state.selected_type;

    return selectedType ? (
      <React.Fragment>
      <div className='sidebar'>
        <div className='header-'>
          Ваша сейф-дверь
          <div className="header-totals">
            {`${priceFormat(state.total_price)}`}
          </div>
        </div>
        <div className="mobile-show">
          <div className='selected-type-title'>{_.get(selectedType, 'title')}</div>
        </div>
        <div className='content-'>
          <div className='door-preview-block'>
            { this.renderLayers(state.preview_layers) }
            <div className='door-preview-block-info'>
              <div className='door-preview-block-title'>{_.get(selectedType, 'title')}</div>
              <div className='door-preview-block-parts'>
                <ul className='door-preview-block-parts-list'>
                  { this.renderOptions() }
                </ul>
              </div>
            </div>
            <div className='door-preview-block-comment'>
              { state.comment }
            </div>

            <div className='door-preview-block-total-price'>
              {`${priceFormat(state.total_price)}`}
            </div>
          </div>
        </div>
      </div>
      { this.state.showModalPreview && this.renderPreviewPopup() }
      </React.Fragment>
    ) : null;
  }
}

const mapStateToProps = (state) => {
  return {
    constructions_state: state.constructionsState,
    preview_state: state.doorPreviewState,
    app: state.applicationState
  }
};

const mapDispatch = (dispatch) => {
  return {
    constructions_actions: bindActionCreators(constructionsActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatch, null, {pure: false})(DoorPreview);





// WEBPACK FOOTER //
// ./app/javascript/app/components/door_preview/index.jsx